import {
  ITheme,
  IThemeSchema,
  defaultLightTheme,
  mergeTheme,
} from "smarthub-common";

export const genericTheme: ITheme = mergeTheme(
  {
    $id: "example-light",
    $schema: IThemeSchema,
    name: "Light Theme",
    description: "Applies default colour scheme to the SmartHub",
    definition: {
      type: "light",
      image: {
        launchButtonLeft:
          "https://www.lewes-eastbourne.gov.uk/image/3631/Ellis-Left/gi-responsive__100.png",
        launchButtonRight:
          "https://www.lewes-eastbourne.gov.uk/image/3628/Ellis-Right/gi-responsive__100.png",
        chatHead:
          "https://lec-prod.lewes-eastbourne.gov.uk/chat/image/Ask-ELLIS-Header-Logo.png",
        botAvatar:
          "https://lec-prod.lewes-eastbourne.gov.uk/chat/image/Ask-ELLIS-Bot-Avatar-Logo.png",
      },
      palette: {
        primaryNavText: "#fff",
        primaryNavBackground: "#525659",
        neutralFull: "#222",
        neutralFullOn: "#fff",
        neutralPlus5: "#201f1e",
        neutralPlus5On: "#fff",
        neutralPlus4: "#323130",
        neutralPlus4On: "#fff",
        neutralPlus3: "#3b3a39",
        neutralPlus3On: "#fff",
        neutralPlus2: "#525659",
        neutralPlus2On: "#fff",
        neutralPlus1: "#a19f9d",
        neutralPlus1On: "#000",
        neutral: "#c8c8c8",
        neutralOn: "#111",
        neutralMinus1: "#d0d0d0",
        neutralMinus1On: "#222",
        neutralMinus2: "#dadada",
        neutralMinus2On: "#333",
        neutralMinus3: "#eaeaea",
        neutralMinus3On: "#444",
        neutralMinus4: "#f4f4f4",
        neutralMinus4On: "#444",
        neutralMinus5: "#f8f8f8",
        neutralMinus5On: "#444",
        neutralEmpty: "#fff", // input bg color, bot response bg color, header menu bg color
        neutralEmptyOn: "#222", // bot response text and response meta
        primaryFull: "#153f3e",
        primaryFullOn: "#eee",
        primaryPlus2: "#000", // hover bg for hint cards
        primaryPlus2On: "#fff", // hover bg hint cart text
        primaryPlus1: "#226564",
        primaryPlus1On: "#fff",
        primary: "#486c7a",
        primaryOn: "#fff", // header nav text, hint button text
        primaryMinus1: "#368180",
        primaryMinus1On: "#fff",
        primaryMinus2: "#486c7a", // border bottom for input box
        primaryMinus2On: "#fff",
        primaryMinus3: "#66a9a8",
        primaryMinus3On: "#333",
        primaryMinus4: "#aad4d3",
        primaryMinus4On: "#444",
        primaryEmpty: "#d0e8e8",
        primaryEmptyOn: "#444",
        filmPlus1: "#000000A6",
        filmPlus1On: "#fff",
        film: "#33959499",
        filmOn: "#fff",
        filmVar: "#73bfbd99",
        filmVarOn: "#222",
        filmMinus1: "#00000077",
        filmMinus1On: "#fff",
        neutalFilm: "#33333399",
        neutalFilmOn: "#fff",
        neutalFilmMinus1: "#ffffff99",
        neutalFilmMinus1On: "#000",
        neutalFilmMinus2: "#ffffffcc",
        neutalFilmMinus2On: "#000",
      },
      styles: {
        chat: {
          header: {
            root: {
              backgroundColor: "#ca006e",
              color: "#fff",
            },
          },
        },
      },
    },
  },
  defaultLightTheme
);
